import type { UploaderMethodProps } from 'src/app/shared/components/imageUpload';

import type { PetitionUpdateError } from '../../types';

type UploadImageResult = {
	isSuccess: boolean;
	error?: PetitionUpdateError;
	uploadURL?: string;
};

export async function uploadImage(uploader: UploaderMethodProps): Promise<UploadImageResult> {
	try {
		const result = await uploader.upload();
		const successful = result?.successful || [];
		// FIXME should we handle an empty array here?
		const { uploadURL } = successful[0];
		return {
			isSuccess: true,
			uploadURL,
		};
	} catch (e: unknown) {
		return {
			isSuccess: false,
			error: { message: 'Error uploading the image', type: 'UPLOAD_ERROR' },
		};
	}
}
